import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { IconButton, Tooltip } from "@mui/material";
import {
    MaterialReactTable,
    useMaterialReactTable
} from "material-react-table";
import { useMemo } from "react";
import { tableConfig } from "../../../commons/table/config/tableConfig";
import TitleContainer from "../../../commons/table/utilsTable/titleWithFetchData";

const NotificacionPlantillasTable = ({ data, loading, onEdit, onDelete, fetchData }) => {
    const columns = useMemo(
        () => [
            {
                header: "Nombre",
                accessorKey: "nombre",
            },
            {
                header: "Categoria",
                accessorKey: "categoria",
            },
            {
                header: "Descripcion",
                accessorKey: "descripcion",
            },
            {
                header: "Acciones",
                accessorKey: "acciones",
                enableColumnFilter: false,
                enableSorting: false,
                size: 90,
                Cell: ({ row }) => (
                    <>
                        <Tooltip title="Editar">
                            <IconButton size="small" onClick={() => onEdit(row.original)}>
                                <EditIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Eliminar">
                            <IconButton
                                size="small"
                                onClick={() => onDelete(row.original.id)}>
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </>
                ),
            },
        ],
        [onDelete, onEdit],
    );

    const table = useMaterialReactTable({
        ...tableConfig,
        columns,
        data: data || [],
        state: { isLoading: loading },
        renderTopToolbarCustomActions: () => (
            <TitleContainer title="Plantillas Notificaciones" fetchData={fetchData} />
        ),
    });

    return <MaterialReactTable table={table} />;
};

export default NotificacionPlantillasTable;
